import { GenericAbortSignal } from 'axios';
import { https } from 'core/services/https';
import { baseUrl as navigationBaseUrl } from '../navigation/navigation.data';
import {
  IGetCatalogProductsDTO,
  IGetCatalogProductsParams,
  IGetListProductsDTO,
  IGetListProductsParams,
  IGetProductDetailParams,
  IGetSuggestionsParams,
  IProductDetailDTO,
  TGetSuggestionsDTO,
} from './catalogs.dto';

export const baseUrl = '/v1/products';

export const catalogsData = {
  getListProducts: async (
    params: IGetListProductsParams,
    customerId: number,
    signal?: GenericAbortSignal,
  ): Promise<IGetListProductsDTO> => {
    const data = await https.get<IGetListProductsDTO>(baseUrl, {
      params,
      headers: { 'Gtm-Customer-Id': customerId },
      signal,
    });

    return data;
  },

  getProductDetail: async ({ sku }: IGetProductDetailParams, customerId: number): Promise<IProductDetailDTO> => {
    const data = await https.get<IProductDetailDTO>(`${baseUrl}/${sku}`, {
      headers: { 'Gtm-Customer-Id': customerId },
    });

    return data;
  },

  getCatalogProducts: async (
    params: IGetCatalogProductsParams,
    customerId: number,
  ): Promise<IGetCatalogProductsDTO> => {
    const data = await https.get<IGetCatalogProductsDTO>(`${navigationBaseUrl}/products`, {
      params,
      headers: { 'Gtm-Customer-Id': customerId },
    });

    return data;
  },

  getSuggestions: async (params: IGetSuggestionsParams, customerId: number): Promise<TGetSuggestionsDTO> => {
    const data = await https.get<TGetSuggestionsDTO>(`${baseUrl}`, {
      params,
      headers: { 'Gtm-Customer-id': customerId },
    });

    return data;
  },
};
